<template>
    <section class="customerDetails">
        <van-nav-bar title="客户详情" left-arrow class="top_bar" @click-left="onClickNavLeft">
            <!-- <template #right>
                <a :href="'tel:' + cus_brief.phone">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <g clip-path="url(#clip0_376_2399)">
                            <mask id="mask0_376_2399" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="22">
                            <path d="M22 0H0V22H22V0Z" fill="white"/>
                            </mask>
                            <g mask="url(#mask0_376_2399)">
                            <path d="M18.7798 16.7918L15.0535 13.4038C14.8774 13.2437 14.6459 13.1583 14.408 13.1657C14.1701 13.1731 13.9443 13.2725 13.7784 13.4432L11.5849 15.6991C11.0568 15.5983 9.99539 15.2674 8.90267 14.1775C7.80998 13.0839 7.4791 12.0196 7.38097 11.4953L9.63505 9.30079C9.80601 9.13498 9.90565 8.9092 9.91298 8.67122C9.92041 8.43325 9.83479 8.20175 9.67456 8.02572L6.28739 4.30038C6.12704 4.12378 5.90414 4.01667 5.66602 4.00179C5.42802 3.9869 5.19348 4.0654 5.01232 4.22062L3.02322 5.92654C2.86466 6.0856 2.77011 6.29729 2.75735 6.52147C2.74359 6.75063 2.48141 12.1791 6.69078 16.3903C10.363 20.0616 14.9627 20.3301 16.2296 20.3301C16.4147 20.3301 16.5284 20.3246 16.5587 20.3228C16.7828 20.3102 16.9943 20.2153 17.1526 20.056L18.8576 18.066C19.0136 17.8854 19.0927 17.6511 19.0781 17.413C19.0634 17.175 18.9564 16.952 18.7798 16.7918Z" fill="#0DDEF4"/>
                            </g>
                        </g>
                        <defs>
                            <clipPath id="clip0_376_2399">
                            <rect width="22" height="22" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </a>
            </template> -->
        </van-nav-bar>
        <section class="cus_brief">
            <div class="item">
                <p @click="onChangeSalesmanClick">
                    <span v-if="!isLoading && cus_brief.currentSalesmanName">{{cus_brief.currentSalesmanName}}</span>
                    <span v-if="!isLoading && !cus_brief.currentSalesmanName" class="todo">待分配</span>
                    <img src="../../assets/img/cus_select_icon.svg" alt="">
                </p>
                <p>业务员</p>
            </div>
            <div class="item">
                <p @click="showFollowUpForm = true">
                    <span>{{cus_brief.followUpCount || 0}}</span>
                    <img src="../../assets/img/cus_add_icon.svg" alt="">
                </p>
                <p>跟进次数</p>
            </div>
            <div class="item">
                <p @click="showQualificationLabelPicker = true">
                    <span v-if="cus_brief.qualificationLabel == 1">资质较差</span>
                    <span v-else-if="cus_brief.qualificationLabel == 2">资质一般</span>
                    <span v-else-if="cus_brief.qualificationLabel == 3">资质良好</span>
                    <span v-else>-</span>
                    <img src="../../assets/img/cus_select_icon.svg" alt="">
                </p>
                <p>资质标签</p>
            </div>
            <div class="item">
                <p @click="showBusinessStatusPicker = true">
                    <span>{{cus_brief.businessStatus | f_businessStatus}}</span>
                    <img src="../../assets/img/cus_select_icon.svg" alt="">
                </p>
                <p>业务状态</p>
            </div>            
        </section>
        <section class="cus_details">
            <van-tabs color="#055CE8" sticky offset-top="1.179rem"  animated swipeable>
                <van-tab title="客户资料">
                    <CusInfoList :id="id" />
                </van-tab>
                <van-tab title="跟进记录">
                    <CusFollowList :key="refreshKey" :customerCode="cus_brief.customerCode" />
                </van-tab>
                <van-tab title="流转记录">
                    <CusFlowList :key='refreshKeyFlow' :id="id" />
                </van-tab>
            </van-tabs>
        </section>  
        <section>
            <div class="button_area">
                <van-button round block type="primary" to="/customer" native-type="submit">返回</van-button>                
            </div>
        </section>

        <van-popup v-model="showChangeCusTeamPicker" round position="center" style="width: 70%">
            <van-picker
                show-toolbar
                title = '归属团队'
                :columns="teamList"
                @cancel="showChangeCusTeamPicker = false"
                @confirm="onChangeCusTeamPickerConfirm"
            />
        </van-popup>

        <van-popup v-model="showChangeCusSalesmanPicker" round position="center" style="width: 70%">
            <van-picker
                show-toolbar
                title = '归属业务员'
                :columns="salesmanList"
                @cancel="showChangeCusSalesmanPicker = false"
                @confirm="onChangeCusSalesmanPickerConfirm"
            />
        </van-popup>

        <van-popup v-model="showQualificationLabelPicker" round position="center" style="width: 70%">
            <van-picker
                show-toolbar
                title = '资质标签'
                :columns="qualificationLabelList"
                @cancel="showQualificationLabelPicker = false"
                @confirm="onQualificationLabelPickerConfirm"
            />
        </van-popup>

        <van-popup v-model="showBusinessStatusPicker" round position="center" style="width: 70%">
            <van-picker
                show-toolbar
                title = '业务状态'
                :columns="businessStatusList"
                @cancel="showBusinessStatusPicker = false"
                @confirm="onBusinessStatusPickerConfirm"
            />
        </van-popup>

        <van-popup round v-model="showFollowUpForm" :style="{ width: '90%' }">
            <van-form @submit="onSubmitFollow">
                <van-field name="followUpMethod" label="跟进方式" :rules="[{ required: true, message: '请选择跟进方式' }]">
                    <template #input>
                        <van-radio-group v-model="followUpForm.followUpMethod" direction="horizontal">
                            <van-radio v-for="item in followUpMethodList" :name="item.value" :key="item.vaule">{{item.text}}</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>

                <van-field name="followUpLabel" label="跟进标签" :rules="[{ required: true, message: '请选择跟进标签' }]">
                    <template #input>
                        <van-radio-group v-model="followUpForm.followUpLabel" direction="horizontal">
                            <van-radio v-for="item in followUpLabelList" :name="item.value" :key="item.vaule">{{item.text}}</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>

                <van-field
                    v-model="followUpForm.followUpDescription"
                    name="followUpDescription"
                    label="跟进描述"
                    placeholder="请填写跟进描述，至少10个字"
                    type="textarea"
                    rows="2"
                    autosize
                    maxlength="150"
                    show-word-limit
                    :rules="[
                        { required: true, message: '请填写跟进描述' },
                        { pattern: /^.{10,}$/, message: '至少10个字' },
                    ]"
                />

                <div style="margin: 16px;">
                    <van-button 
                        round 
                        block 
                        type="primary" 
                        native-type="submit"
                        :loading="isSubmitting"
                        :disabled="isSubmitting"
                    >
                        {{ isSubmitting ? '提交中...' : '提交' }}
                    </van-button>
                </div>
            </van-form>
        </van-popup>
	</section>
</template>

<script>
import Nav from "components/Nav"
import CusInfoList from "components/CusInfoList"
import CusFollowList from "components/CusFollowList"
import CusFlowList from "components/CusFlowList"

import customerServer from "api/customer"
import teamServer from "api/team"

import { Toast } from "vant"

export default {
    name: "customerDetails",
	components: {
		Nav,
        CusInfoList,
        CusFollowList,
        CusFlowList
	},
    data() {
        return {
            refreshKey: 0,
            refreshKeyFlow: 0,

            id: 0,
            cus_brief: {},

            showQualificationLabelPicker: false,
            qualificationLabelList: [
                { text: '资质较差', value: 1 },
                { text: '资质一般', value: 2 },
                { text: '资质良好', value: 3 },
            ],

            showBusinessStatusPicker: false,
            businessStatusList: [
                { text: '待跟进', value: 0 },
                { text: '跟进中', value: 1 },
                { text: '已到店', value: 2 },
                { text: '已签约', value: 3 },
                { text: '进件中', value: 4 },
                { text: '审核失败', value: 5 },
                { text: '审核通过', value: 6 },
                { text: '已放款', value: 7 },
                { text: '已完结', value: 8 },
                { text: '已终止', value: 9 },
            ],

            showFollowUpForm: false,
            isSubmitting: false,
            followUpForm: {
                followUpMethod: 1,
            },

            followUpMethodList: [
                { text: '电话', value: 1 },
                { text: '微信', value: 2 },
                { text: '短信', value: 3 },
                { text: '现场', value: 4 },
                { text: '其他', value: 5 },
            ],

            followUpLabelList: [
                { text: '联系方式无效', value: 1 },
                { text: '拒绝沟通', value: 2 },
                { text: '无需求', value: 3 },
                { text: '需求模糊可挖掘', value: 4 },
                { text: '需求明确', value: 5 },
            ],

            teamList: [],
            salesmanList: [],

            showChangeCusTeamPicker: false,
            showChangeCusSalesmanPicker: false,

            accountType: '',
            isLoading: true,
		};
    },

    created() {
        this.id = this.$route.params.id
        this.getCusInfo()

        this.accountType = localStorage.getItem('accountType')

        if (this.accountType == 0) {
            this.getTeamInfo()
            this.getSalesmanInfo()
        } else if (this.accountType == 1) {
            this.getSalesmanInfo()
        }
	},
    
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},

    methods: {
        getCusInfo() {
            this.isLoading = true
            customerServer.getCustomerPageList({id: this.id, pageNum:1, pageSize:100}).then((res) => {
                this.cus_brief = res.data.list[0]
                this.isLoading = false
            })
        },

        getTeamInfo() {
            teamServer.getTeamPageList({"pageNum": 1, "pageSize": 1000}).then((res) => {
                if (res.data.total) {
                    res.data.list.forEach(team => {
                        this.teamList.push({"text": team.teamName, "teamId": team.id});
                    });

                    // 使用 sort() 方法对 teamList 数组进行排序
                    this.teamList.sort((a, b) => a.teamId - b.teamId);

                    console.log(this.teamList)
                } else {
                    this.teamList = []
                }
            })
        },

        getSalesmanInfo() {
            teamServer.getOrgUserPageList({"pageNum": 1, "pageSize": 1000, "accountType": 2}).then((res) => {
                if (res.data.total) {
                    res.data.list.forEach(salesman => {
                        let text = ''
                        if (salesman.teamName) {
                            text = salesman.name + '[' + salesman.teamName + ']' 
                        } else {
                            text = salesman.name
                        }

                        this.salesmanList.push({"text": text, "salesmanId": salesman.id, "teamId": salesman.teamId});
                    });

                    // 使用 sort() 方法对 salesmanList 数组进行排序
                    this.salesmanList.sort((a, b) => a.teamId - b.teamId);

                    console.log(this.salesmanList)
                } else {
                    this.salesmanList = []
                }
            })
        },

        onClickNavLeft() {
            this.$router.go(-1);
        },

        onChangeTeamClick() {
            if (this.accountType == 0) {
                this.showChangeCusTeamPicker = true
            }

            if (this.accountType == 1) {
                Toast('请联系机构管理员转单到其他团队')
            }

            if (this.accountType == 2) {
                Toast('请联系团队管理员转单到其他团队')
            }
        },

        onChangeCusTeamPickerConfirm(item, index) {
            this.showChangeCusTeamPicker = false

            customerServer.RedistributeCus({id: this.id, teamId: item.teamId}).then((res) => {
                Toast('已分配到新团队')
                this.getCusInfo()
                this.refreshKeyFlow++
            })
        },

        onChangeSalesmanClick() {
            if (this.accountType == 0 || this.accountType == 1) {
                this.showChangeCusSalesmanPicker = true
            }

            if (this.accountType == 2) {
                Toast('请联系团队管理员转单')
            }
        },

        onChangeCusSalesmanPickerConfirm(item, index) {
            this.showChangeCusSalesmanPicker = false

            customerServer.RedistributeCus({id: this.id, salesmanId: item.salesmanId}).then((res) => {
                Toast('已分配到新业务员')
                this.getCusInfo()
                this.refreshKeyFlow++
            })
        },

        onQualificationLabelPickerConfirm(item, index) {
            this.showQualificationLabelPicker = false

            customerServer.updateCusQualificationLabel({id: this.id, qualificationLabel: item.value}).then((res) => {
                Toast('更新资质标签成功')
                this.getCusInfo()
            })
        },

        onBusinessStatusPickerConfirm(item, index) {
            this.showBusinessStatusPicker = false

            customerServer.updateCusBusinessStatus({id: this.id, businessStatus: item.value}).then((res) => {
                Toast('更新业务状态成功')
                this.getCusInfo()
            })
        },

        onSubmitFollow() {
            // 防止重复提交
            if (this.isSubmitting) {
                return
            }
            
            this.isSubmitting = true
            this.followUpForm.customerId = this.id
            console.log(this.followUpForm)
            customerServer.addFollowUp( this.followUpForm ).then( (res) => {
                this.showFollowUpForm = false

                this.followUpForm = {}
                this.followUpForm.followUpMethod = 1
                
                Toast('添加跟进记录成功')

                // 首次添加跟进记录且业务状态是待跟进，则自动修改业务状态为跟进中
                if(this.cus_brief.followUpCount==0 && this.cus_brief.businessStatus == 0) {
                    customerServer.updateCusBusinessStatus({id: this.id, businessStatus: 1}).then((res) => {
                        Toast('业务状态自动更新为跟进中')
                    })
                }

                this.getCusInfo()
                this.refreshKey++
                this.isSubmitting = false
            }).catch((error) => {
                this.isSubmitting = false
                console.error('提交跟进记录失败:', error)
            })
        }
    },
};
</script>

<style lang="scss">
	.customerDetails {
		padding-top: 46px;
		padding-bottom: 100px;

        .cus_brief {
            border-radius: 24px;
            background: linear-gradient(180deg, #F4F6FC 0%, #FFF 54.76%, #FFF 100%);
            padding-top: 33px;
            display: flex;
            flex-wrap: wrap;

            .item {
                flex: 0 0 calc(100% / 3);
                padding-left: 20px;
                padding-right: 10px;
                margin-bottom: 33px;

                p:first-child {
                    color: #4D5B80;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 22px;
                    display: flex;
                    align-items: center;

                    span{
                        margin-right: 4px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    span.todo {
                        color: #E80505;
                    }
                }

                p:last-child {
                    margin-top: 8px;
                    color: #8F9CC2;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                }
            }

            .item:nth-child(1), .item:nth-child(2), .item:nth-child(4) {
                border-right: 1px dotted #DBDDE1;
                max-width: calc(100% / 3);
            }

            .item:last-child {
                flex: 0 0 calc(100% / 3 * 2);
            }
        }

        .cus_details {
            margin-top: 22px;
        }

        .button_area {
            position: fixed;
            bottom: 30px;
            width: 100%;
            padding: 0 28px;
        }

        .van-tabs__content {
            margin-top: 12px;
        }

        .van-radio--horizontal{
            margin-bottom: 12px;
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/customer/Details.vue